const safeProtocols = ['http:', 'https:']

/** The URL when it is an absolute http(s) URL, otherwise undefined, so `javascript:` and `data:` URLs never reach a link or image. */
export const toSafeHttpUrl = (url: string | null | undefined): string | undefined => {
  const trimmed = url?.trim()
  if (!trimmed) return undefined
  try {
    return safeProtocols.includes(new URL(trimmed).protocol) ? trimmed : undefined
  } catch {
    return undefined
  }
}
